import { getI18nText } from 'pricing-pages-lib/utils/languageUtils';
import { useHistory } from 'react-router-dom';
import { MERCH_CARD } from '../../../../constants/tracking/TrackingSources';
import { trackClickedLink } from '../../../../utils/tracking/trackingEventUtils';
import { UncategorizedPriorityFeatures } from '../../../../v2/components/merch-card/feature-display/UncategorizedPriorityFeatures';
import { useIsFreePortal } from '../../../../v2/hooks/useProductInventory';
import SkeletonLoadWrapper from '../../../common/loading/SkeletonLoadWrapper';
import { StandardLowerTierMessage } from '../StandardLowerTierMessage';
import { useFTS0017AndFTS0018Features } from '../useFTS0017AndFTS0018Features';
import { BrandingAndUncategorizedFeaturesDisplay } from '../../../../v2/components/merch-card/feature-display/BrandingAndUncategorizedFeaturesDisplay';
import { useAppSelector } from '../../../../reducers';
import { isUngatedForInbound25Selector } from '../../../../selectors/GatingSelectors';

// Copy of StandardFeaturesContainer but modified for the FTS0017 and FTS0018 experiment

/**
 * --- >>> NOTE <<< ----
 * IF THIS EXPERIMENT IS PRODUCTIZED, THIS component should be removed, NOT the StandardFeaturesContainer
 * The experiment is hard-coding the features we're choosing to display
 * on the FE, but if we productize, then the business objectives returned from the BE
 * will need to officially be updated to the new set of features.
 * Once that update is complete, StandardFeaturesContainer can
 * be used and this component can be removed.
 * --- >>> NOTE <<< ----
 */
import { jsx as _jsx } from "react/jsx-runtime";
export const FTS0017orFTS0018FeaturesContainer = ({
  productLevel,
  productLine,
  apiName,
  isCollapsible = false
}) => {
  const {
    isFreePortal,
    loading: isInventoryLoading
  } = useIsFreePortal();
  const isUngatedForInbound25 = useAppSelector(isUngatedForInbound25Selector);
  const {
    loading: isPriorityFeaturesLoading,
    brandingAndLimitFeatures,
    uncategorizedFeatures
  } = useFTS0017AndFTS0018Features({
    apiName
  });
  const loading = isInventoryLoading || isPriorityFeaturesLoading;
  const history = useHistory();
  const handleClick = () => {
    trackClickedLink({
      name: 'business-objective-link',
      value: getI18nText('merchCards.priorityFeatures.freeToolsWithLimits', {
        locale: 'en-us'
      }),
      type: 'internal',
      url: '/crm',
      trackingSource: MERCH_CARD
    });
    history.push('/crm');
  };
  return /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
    isLoading: loading,
    heights: [48, 48],
    widths: ['100%', '100%'],
    children: isUngatedForInbound25 ? uncategorizedFeatures.length ? /*#__PURE__*/_jsx(UncategorizedPriorityFeatures, {
      uncategorizedFeatures: uncategorizedFeatures,
      lowerTierMessage: /*#__PURE__*/_jsx(StandardLowerTierMessage, {
        productLevel: productLevel,
        productLine: productLine,
        handleClick: handleClick,
        isFreePortal: isFreePortal
      }),
      isCollapsible: isCollapsible
    }) : null : /*#__PURE__*/_jsx(BrandingAndUncategorizedFeaturesDisplay, {
      brandingAndLimitFeatures: brandingAndLimitFeatures,
      uncategorizedFeatures: uncategorizedFeatures,
      handleClick: handleClick,
      isCollapsible: isCollapsible,
      isFreePortal: isFreePortal,
      productLevel: productLevel,
      productLine: productLine
    })
  });
};